<script setup>
import { computed } from 'vue'
import moment from 'moment'

// AbuseIPDB report-count cell. Sideloaded like observations (spinner while
// `pending`); shows the total report count plus a muted "last reported N ago"
// badge derived from last_reported_at.
const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  pending: {
    type: Boolean,
    default: false
  }
})

const reports = computed(() => {
  const n = props.data?.total_reports
  return typeof n === 'number' ? n : 0
})

const hasData = computed(() => reports.value > 0)

const displayCount = computed(() => reports.value.toLocaleString())

const lastReported = computed(() => {
  const ts = props.data?.last_reported_at
  return ts ? moment(ts).fromNow() : null
})
</script>

<template>
  <div v-if="pending" class="abuse-pending" aria-label="Loading abuse reports">
    <span class="abuse-spinner"></span>
  </div>
  <div v-else-if="hasData" class="abuse-reports">
    <span class="abuse-count">{{ displayCount }}</span>
    <span v-if="lastReported" class="abuse-last">(last reported {{ lastReported }})</span>
  </div>
</template>

<style scoped>
.abuse-reports {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
  max-width: 100%;
}

.abuse-count {
  flex: 0 0 auto;
  font-variant-numeric: tabular-nums;
}

.abuse-last {
  flex: 0 1 auto;
  min-width: 0;
  color: var(--text-muted);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.abuse-pending {
  display: inline-flex;
  align-items: center;
}

.abuse-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid var(--surface-control);
  border-top-color: var(--accent);
  border-radius: var(--radius-pill);
  animation: abuse-reports-spin 1s linear infinite;
}

@keyframes abuse-reports-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
